import { storesNameRoot } from '../consts';

export const sberIdStoreName = storesNameRoot + '/sberId';
